import { render, staticRenderFns } from "./successfulCertification.vue?vue&type=template&id=18231a1f&scoped=true&"
import script from "./successfulCertification.vue?vue&type=script&lang=js&"
export * from "./successfulCertification.vue?vue&type=script&lang=js&"
import style0 from "./successfulCertification.vue?vue&type=style&index=0&id=18231a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18231a1f",
  null
  
)

export default component.exports